module.exports = __webpack_public_path__ + "img/hero.79d4d89a.png";